import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  map,
  catchError,
  takeUntil,
} from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';

import { AppsService } from 'app/services';
import { App } from 'app/models';

@Injectable()
export class CanManageAppGuardService implements OnDestroy {

  private onDestroy$ = new Subject<void>();

  constructor(
    private _appsService: AppsService,
    private _router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    return this._appsService.apps$
    .pipe(
      map((apps: App[]) => {
        const hasAccess = apps.find(app => app.clientId === route.params.id).isUserAdmin;
        if (hasAccess) {
          return true;
        }
        return this._router.navigate(['']);
      }),
      catchError(error => of(false)),
      takeUntil(this.onDestroy$)
    );
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
